import apiClient from './apiClient';

// List operations grouped by module (paginated + server-side search)
export const listOperations = async ({ page = 1, pageSize = 8, search = '' } = {}) => {
  const response = await apiClient.get('/admin/operations-manager/list', {
    params: { page, page_size: pageSize, search },
  });
  return response.data;
};

// Toggle an operation's visibility flag
// field: 'show_in_user_management' | 'show_in_tracker'
export const toggleOperation = async (operationKey, field, value) => {
  const response = await apiClient.put('/admin/operations-manager/toggle', {
    operation_key: operationKey,
    field,
    value,
  });
  return response.data;
};
